module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" title=\"")
    ; __append(escapeFn(title))
    ; __append("\" style=\"display: none;\">\r\n    ")
    ; __append(text)
    ; __append("\r\n\r\n    <div id=\"dialog-check-input\" style=\"bottom: 0px; position: absolute;\">\r\n        <input type=\"checkbox\" /> ")
    ; __append(escapeFn(checkboxText))
    ; __append("\r\n    </div>\r\n</div>")
  }
  return __output;

}